document.addEventListener('turbolinks:load', () => {
    $('select.show-next-if-email').on('change', function() {
        const $this = $(this);
        const $siblings = $this.closest('.form-group').find('.default-hidden');
        if ($siblings.length) {
            $siblings.addClass('hide');
            const val = $this.val();
            if (val === 'email') {
                $siblings.removeClass('hide');
                $siblings.find('input[type="email"]').attr('required', true);
            } else {
                $siblings.find('input[type="email"]').attr('required', false);
            }
        }
    });

    $('select.show-next-if-email').trigger('change');
});